import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Toolbar from 'widgets/Toolbar';
import List from 'widgets/List';
import Popover from 'widgets/Popover';
import Button from 'widgets/Button';
import colors from 'assets/styles/jsVariables/colors';
import Icon from 'components/Icon';
import UserAvatar from 'components/UserAvatar';
import CountryDrop from 'components/CountryDrop';
import { endPoints } from 'config/routes';
import {
  logInApp,
  clickMenuContactUs,
  clickSignOutApp
} from 'libs/cleverTap';
import { handleLogoutUser, resetUser } from 'redux/actions/auth';
import { selectCountry } from 'redux/actions/location';
import _ from 'lodash';

import './Header.scss';

const styles = {
  toolbarStyle: {
    height: '64px',
    backgroundColor: colors.white,
    padding: '0px',
    margin: '0 20px',
    '@media (max-width: 1023px)': {
      margin: '0 15px'
    }
  },
  iconButtonStyle: {
    '&:hover': {
      background: 'none'
    }
  },
  buttonStyle: {
    height: 48,
    paddingLeft: 16,
    paddingRight: 16,
    marginTop: 7,
    '&:hover': {
      background: 'none'
    },
    '@media (max-width: 1023px)': {
      paddingRight: 0
    }
  },
  PopoverStyle: {
    borderRadius: '2px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px',
    overflowX: 'visible',
    overflowY: 'visible',
    right: 16,
    left: 'auto !important'
  },
  ListItemStyle: {
    '&:hover': {
      backgroundColor: colors.lightestGrey
    }
  },
  AvatarStyle: {
    height: 30,
    width: 30,
  }
};

const ListItemsMap = [{
  component() {
    const { signOutLabelText } = this.props;
    return (
      <List
        type="listItem"
        button
        key="Sign Out"
        id="signOutHeader"
        onClick={() => {
          clickSignOutApp();
          this.props.handleLogoutUser();
          this.setState({ open: false });
        }}
        style={{ color: colors.darkGrey, paddingLeft: 25 }}
      >
        <List type="listItemIcon">
          <Icon
            name="logout-icon"
            fill={colors.lightGrey}
            style={{ height: 20, width: 20 }}
          />
        </List>
        <List type="listItemText">
          {signOutLabelText}
        </List>
      </List>
    );
  }
},
{
  component() {
    const { contactUsLabelText } = this.props;
    return (
      <a
        key="Contact Us"
        href="https://choosemuse.com/contactsupport"
        style={{ textDecoration: 'none' }}
      >
        <List
          type="listItem"
          button
          onClick={() => {
            clickMenuContactUs();
            this.setState({ open: false });
          }}
          style={{ color: colors.darkGrey, paddingLeft: 25 }}
        >
          <List type="listItemIcon">
            <Icon
              name="email-icon"
              fill={colors.lightGrey}
              style={{ height: 20, width: 20 }}
            />
          </List>
          <List type="listItemText">
            {contactUsLabelText}
          </List>
        </List>
      </a>
    );
  }
}];

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  componentDidMount() {
    const { user } = this.props;
    if (!_.isEmpty(user)) {
      // push login event into clevertap
      logInApp(user);
    }
  }

  componentWillReceiveProps(props) {
    const { windowDimension } = props;
    const nextWindowWidth = windowDimension.innerWidth;
    const currentWindowWidth = this.props.windowDimension
                               && this.props.windowDimension.innerWidth;
    if (currentWindowWidth && currentWindowWidth !== nextWindowWidth) {
      props.closeSideBar();
    }
  }

  handleTouchTap = (event) => {
    // This prevents ghost click.
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  }

  handleLogoRedirect = (_pathname) => {
    const { pathname } = window.appHistory && window.appHistory.location;
    if (_pathname !== pathname) {
      this.props.resetUser(() => window.appHistory.push(_pathname));
    }
  }

  render() {
    const {
      toggleSidebar,
      user,
      showMenuIconMobile,
      showPopover,
      hamburgerClass,
      imagePaths,
      rootStyle,
      popoverIconFill,
      profileIconStyle,
      chevronIconStyle,
      logoRedirect,
      showUserAvatar,
      location, showCountryDrop
    } = this.props;

    const {
      open,
      anchorEl
    } = this.state;
    return (
      <div className="Header museAccountPrintHeader" >
        <Toolbar
          cssStyles={{
            root: styles.toolbarStyle
          }}
          style={rootStyle}
        >
          <div style={{ minWidth: '200px' }}>
            {
              showMenuIconMobile &&
              <Button
                type="icon"
                className={hamburgerClass}
                onClick={toggleSidebar}
                cssStyles={{ root: styles.iconButtonStyle }}
                style={{
                  margin: '0px',
                  padding: '20px 15px 20px 0px',
                  borderRadius: '0px',
                  '&:hover': {
                    backgroundColor: 'initial',
                  },
                }}
              >
                <Icon name="menu-icon" fill="#7d7d7d" style={{ width: '18px', height: '23px' }} />
              </Button>
            }
            <span>
              <span
                onClick={() => {
                  const url = logoRedirect.url || endPoints.accountSetting;
                  if (logoRedirect.refresh) {
                    window.open(url, '_self');
                  } else {
                    this.handleLogoRedirect(url);
                  }
                }}
                role="link"
                tabIndex={0}
                style={{ outline: 'none' }}
              >
                <img
                  src={imagePaths.desktopAppLogo}
                  className="Header__Logo Header__Logo-Desktop"
                  alt="Logo"
                />
                <img
                  src={imagePaths.mobileAppLogo}
                  className="Header__Logo Header__Logo-MobileTab"
                  alt="Logo"
                />
              </span>
            </span>
          </div>
          {
            showCountryDrop &&
            <CountryDrop
              handleCountrySelect={this.props.selectCountry}
              selectedCountry={location.info}
            />
          }
          {
            (!_.isEmpty(user) && showUserAvatar) &&
            <div style={{ margin: 0, width: 200 }}>
              <div
                style={{
                  height: 64, margin: 0, position: 'absolute', right: 0, top: 0
                }}
              >
                <Button
                  onClick={this.handleTouchTap}
                  disabled={!showPopover}
                  cssStyles={{ root: styles.buttonStyle }}
                >
                  <React.Fragment>
                    <UserAvatar
                      user={{
                        avatar: user.picture || imagePaths.profileIcon
                      }}
                      style={{ float: 'left', ...profileIconStyle, }}
                      cssStyles={{
                        root: styles.AvatarStyle
                      }}
                    />
                    <div className="Header__NameContainer">
                      {
                        showPopover &&
                        <Icon
                          name={open ? 'chevron-up' : 'chevron-down'}
                          fill={popoverIconFill}
                          style={{
                            height: 16,
                            width: 16,
                            marginBottom: -2,
                            ...chevronIconStyle
                          }}
                        />
                      }
                    </div>
                  </React.Fragment>
                </Button>
                {
                  showPopover &&
                  <Popover
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    onClose={this.handleRequestClose}
                    elevation={2}
                    cssStyles={{ paper: styles.PopoverStyle }}
                    style={{ marginTop: 64, zIndex: 1302 }}
                  >
                    <div style={{ position: 'relative' }}>
                      <List className="Header__MenuPopover" style={{ backgroundColor: 'white' }}>
                        {
                          ListItemsMap.map(item => (
                            item.component &&
                            item.component.call(this)
                          ))
                        }
                      </List>
                    </div>
                  </Popover>
                }
              </div>
            </div>
          }
        </Toolbar>
      </div>
    );
  }
}

Header.propTypes = {
  windowDimension: PropTypes.object.isRequired,
  imagePaths: PropTypes.object.isRequired,
  rootStyle: PropTypes.object,
  profileIconStyle: PropTypes.object,
  chevronIconStyle: PropTypes.object,
  toggleSidebar: PropTypes.func,
  closeSideBar: PropTypes.func,
  selectCountry: PropTypes.func,
  user: PropTypes.object,
  showMenuIconMobile: PropTypes.bool,
  showPopover: PropTypes.bool,
  showCountryDrop: PropTypes.bool,
  showUserAvatar: PropTypes.bool,
  hamburgerClass: PropTypes.string,
  popoverIconFill: PropTypes.string,
  logoRedirect: PropTypes.object,
  location: PropTypes.object.isRequired,
  resetUser: PropTypes.func.isRequired
};

Header.defaultProps = {
  toggleSidebar: () => { },
  closeSideBar: () => { },
  user: {},
  rootStyle: {},
  profileIconStyle: {},
  chevronIconStyle: {},
  showMenuIconMobile: false,
  showPopover: false,
  showUserAvatar: true,
  hamburgerClass: '',
  popoverIconFill: '#7d7d7d',
  logoRedirect: {},
  selectCountry: () => {},
  showCountryDrop: false
};

export default connect(
  ({
    windowDimension,
    auth: { info },
    location
  }) => ({
    windowDimension,
    user: (info && info.user) || undefined,
    location
  }),
  { handleLogoutUser, resetUser, selectCountry }
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx